
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsSalesmanGroupGrid extends Serenity.EntityGrid<PsSalesmanGroupRow, any> {
        protected getColumnsKey() { return PsSalesmanGroupColumns.columnsKey; }
        protected getDialogType() { return PsSalesmanGroupDialog; }
        protected getIdProperty() { return PsSalesmanGroupRow.idProperty; }
        protected getInsertPermission() { return PsSalesmanGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return PsSalesmanGroupRow.localTextPrefix; }
        protected getService() { return PsSalesmanGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}